@if (state.config.betsConfig.winner) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Tournament's winner ({{ state.config.betsConfig.winner.points }})</mat-card-title>
      <mat-card-subtitle>Tournament's winner</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.winnerOptions"
                            [initValue]="state.betting?.winner"
                            [key]="'winner'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.underOver) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Under or over goals</mat-card-title>
      <mat-card-subtitle>
        Total number of goals during the tournament Under or over/equal
        to {{ state.config.betsConfig.underOver.goals }} ({{ state.config.betsConfig.underOver.points }})
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.underOver"
                               [key]="'underOver'"
                               [options]="state.underOverOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.teamsToReachFinals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Teams to reach the finals ({{ state.config.betsConfig.teamsToReachFinals.points }})
      </mat-card-title>
      <mat-card-subtitle>Two teams to get to the finals</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.teamsToReachFinalsOptions"
                            [initValue]="state.betting?.teamsToReachFinals"
                            [key]="'teamsToReachFinals'"
                            [multi]="true"
                            [numOfSelections]="2">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.bestGoalScorer) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Best Goal Scorer ({{ state.config.betsConfig.bestGoalScorer.points }})</mat-card-title>
      <mat-card-subtitle>Tournament's player with most scored goals</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.bestGoalScorerOptions"
                            [initValue]="state.betting?.bestGoalScorer"
                            [key]="'bestGoalScorer'"
                            [multi]="state.isSubmissionMode">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.bestGoalScorerGoals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Best Goal Scorer number of goals ({{ state.config.betsConfig.bestGoalScorerGoals.points }})
      </mat-card-title>
      <mat-card-subtitle>Amount of goals that are scored by the best goal scorer</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.bestGoalScorerGoalsOptions"
                            [initValue]="state.betting?.bestGoalScorerGoals"
                            [key]="'bestGoalScorerGoals'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.mostGoalsInMatch) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Most Goals In Match ({{ state.config.betsConfig.mostGoalsInMatch.points }})</mat-card-title>
      <mat-card-subtitle>Most goals scored in a single match</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.mostGoalsInMatchOptions"
                            [initValue]="state.betting?.mostGoalsInMatch"
                            [key]="'mostGoalsInMatch'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.fastestGoal) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Fastest goal minute ({{ state.config.betsConfig.fastestGoal.points }})</mat-card-title>
      <mat-card-subtitle>The minutes in which the fastest goal will be scored</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.fastestGoalOptions"
                            [initValue]="state.betting?.fastestGoal"
                            [key]="'fastestGoal'">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}
